// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__cfoKr","footer":"Form_footer__3NI0E"};